module.exports = __webpack_public_path__ + "img/pic_feed_bigsale1.e8d00563.png";